"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiDeleteMessage = exports.apiMarkMessageAsRead = exports.apiSendMessageToCourse = exports.apiSendMessageToStudents = exports.apiSendMessageToStudent = exports.apiGetStudentMessages = exports.apiGetStudentUnreadMessages = exports.apiGetUnreadMessageCount = void 0;
const client_1 = require("./client");
const util_1 = require("./util");
/**
 * Get the number of unread messages for the current student.
 * @param after optional timestamp
 * @returns The number of unread messages (after the given timestamp if applicable).
 */
const apiGetUnreadMessageCount = async (after) => {
    const { data: { count } } = await client_1.default.get(`/courses/messages/student/unread/count/${after.getTime()}`);
    return count;
};
exports.apiGetUnreadMessageCount = apiGetUnreadMessageCount;
/**
 * Get the unread messages of the current student.
 * @param after optional timestamp.
 * @param excludeDeleted
 * @returns the unread messages of the student (after the given timestamp if applicable)
 */
const apiGetStudentUnreadMessages = async (after, excludeDeleted = false) => {
    const { data } = await client_1.default.get('/courses/messages/student/unread', {
        params: Object.assign({ excludeDeleted }, (after && { after: after.getTime() })),
    });
    return data;
};
exports.apiGetStudentUnreadMessages = apiGetStudentUnreadMessages;
/**
 * Get all messages of the current student, regardless of their state.
 * @param after optional timestamp
 * @param excludeDeleted
 * @returns the messages of the student (after the given timestamp if applicable)
 */
const apiGetStudentMessages = async (after, excludeDeleted = false) => {
    const { data } = await client_1.default.get('/courses/messages/student/self', {
        params: Object.assign({ excludeDeleted }, (after && { after: after.getTime() })),
    });
    return data;
};
exports.apiGetStudentMessages = apiGetStudentMessages;
/**
 * Send a message to a student.
 *
 * Subject and body will be sanitized before inserting.
 * @param subject subject of the message
 * @param body body of the message
 * @param studentId the student to send it to
 */
const apiSendMessageToStudent = async (subject, body, studentId) => {
    try {
        await client_1.default.post(`/courses/messages/send-to-student/${studentId}`, {
            subject,
            body,
        });
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiSendMessageToStudent = apiSendMessageToStudent;
/**
 * Send a message to multiple students.
 *
 * Subject and Body will be sanitized before inserting.
 * @param courseId
 * @param subject subject of the message
 * @param body body of the message
 * @param studentIds the students to send it to
 */
const apiSendMessageToStudents = async (courseId, subject, body, studentIds) => {
    try {
        await client_1.default.post(`/courses/messages/send-to-students/${courseId}`, {
            subject,
            body,
            studentIds,
        });
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiSendMessageToStudents = apiSendMessageToStudents;
/**
 * Send a message to an entire course.
 *
 * Subject and body will be sanitized before inserting.
 * @param subject subject of the message
 * @param body body of the message
 * @param courseId course to send it to.
 */
const apiSendMessageToCourse = async (subject, body, courseId) => {
    try {
        await client_1.default.post(`/courses/messages/send-to-course/${courseId}`, {
            subject,
            body,
        });
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiSendMessageToCourse = apiSendMessageToCourse;
/**
 * Mark a message as read.
 * @param messageId message to mark
 * @returns the updated message.
 */
const apiMarkMessageAsRead = async (messageId) => {
    const { data } = await client_1.default.post(`/courses/messages/student/mark-as-read/${messageId}`);
    return data;
};
exports.apiMarkMessageAsRead = apiMarkMessageAsRead;
/**
 * Delete a message.
 * @param messageId message to delete.
 */
const apiDeleteMessage = async (messageId) => {
    await client_1.default.delete(`/courses/messages/student/delete/${messageId}`);
};
exports.apiDeleteMessage = apiDeleteMessage;
//# sourceMappingURL=messages.js.map